module.exports = __webpack_public_path__ + "img/cont-04-pari.e2755b53.svg";